<header
    class="w-full shadow-md sticky fixed top-0 left-0 right-0 z-[1000] transition-all duration-300 bg-[#012E26] text-white"
    style="position: fixed !important"
>
    <div class="flex items-center bg-cyan-100 text-[#01211c] py-1 overflow-hidden">
        <div class="hidden w-[20%] xl:flex justify-end">
        </div>
        <div class="w-full xl:w-[60%] overflow-hidden whitespace-nowrap">
            <div class="animate-marquee flex gap-24 text-md font-semibold">
                <a href="https://icit2025.newinti.edu.my/" target="_blank" class="flex justify-between">
                    <img src="assets/img/new-arni.gif" alt="ARNI gif" class="w-[30px] h-[30px]"/>
                    <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT
                        University | 11 Sept 2025 @ INTI International University</p>
                </a>

                <a href="https://icit2025.newinti.edu.my/" target="_blank" class="flex justify-between">
                    <img src="assets/img/new-arni.gif" alt="ARNI gif" class="w-[30px] h-[30px]"/>
                    <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT
                        University | 11 Sept 2025 @ INTI International University</p>
                </a>
            </div>
        </div>

        <div class=" hidden w-[40%] xl:w-[20%] md:flex justify-end gap-x-4 px-4">
            <a href="https://admin.arni.in/" target="_blank"
               class="border border-[#012E26] text-[#012E26] px-4 py-1  hover:text-green-900 hover:border-green-600 hover:bg-white transition text-xs xl:text-sm font-bold rounded shadow-lg">
                Employee Login
            </a>
            <a href="https://student.arni.in/" target="_blank"
               class="border border-[#012E26] text-[#012E26] px-4 py-1  hover:text-green-900 hover:border-green-600 hover:bg-white transition text-xs xl:text-sm font-bold rounded shadow-lg">
                Student Login
            </a>
        </div>
    </div>

    <!--<div class="overflow-hidden whitespace-nowrap bg-cyan-100 text-[#01211c] py-1">
        <div class="animate-marquee flex gap-24 text-md font-semibold">
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11 Sept 2025 @ INTI International University</p>
            </a>
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11 Sept 2025 @ INTI International University</p>
            </a>
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11 Sept 2025 @ INTI International University</p>
            </a>
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11 Sept 2025 @ INTI International University</p>
            </a>
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11 Sept 2025 @ INTI International University</p>
            </a>
            <a href="https://icit2025.newinti.edu.my/" target="_blank" class="inline-block">
                <p> ICIT 2025 – Innovate. Connect. Transform. | In Collaboration with ARNI University & INIT University
                    | 11
                    Sept 2025 @ INTI International University</p>
            </a>

        </div>
    </div>-->

    <div
        class="transition-all duration-300 h-[80px] bg-[#012E26] text-white"
    >
        <div class="container-fluid flex items-center justify-between h-full">
            <!--  <div class="flex items-center h-full pl-4">
                  <a href="/" class="flex items-center">
                      <img
                          [src]="isScrolled ?  'assets/img/logo/arni-golden-logo.png' : 'assets/img/logo/arni-green-logo.png'"
                          alt="ARNI University"
                          class=" transition-all duration-300"
                      />
                  </a>
              </div>-->
            <div class="flex items-center h-full ">
                <a href="/" class="flex items-center">
                    <img
                        src="assets/img/logo/arni-updated-logo.png"
                        alt="ARNI University"
                        class=""
                    />
                </a>
            </div>

            <!-- Desktop navigation -->
            <ul class="hidden lg:flex flex-1 justify-center">
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >ACADEMIC
                    </div><!--/academic-->
                    <!-- Mega Dropdown for Academic -->
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8">
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        PROGRAMS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/graduate" class="block w-full h-full">Graduate</a>
                                        </li>

                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/post-graduate" class="block w-full h-full">Post
                                                Graduate</a>
                                        </li>

                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/doctoral" class="block w-full h-full">Doctoral</a>
                                        </li>

                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/diploma" class="block w-full h-full">Diploma</a>
                                        </li>

                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/integrated" class="block w-full h-full">Integrated</a>
                                        </li>

                                        <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                            <a href="programs/certificate" class="block w-full h-full">Certificate</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        SCHOOLS
                                    </h3>
                                    <div>
                                        <ul class="space-y-2">
                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-technology"> ARNI School of
                                                    Technology</a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-business-management-and-commerce">
                                                    ARNI School of Business Management & Commerce
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-art-and-humanities"
                                                   class="block w-full h-full">
                                                    ARNI School of Art & Humanities
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-basic-science-and-biotechnology"
                                                   class="block w-full h-full">
                                                    ARNI School of Basic Sciences & Bio-Technology
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-paramedical-with-allied-health-science-and-healthcare"
                                                   class="block w-full h-full">
                                                    ARNI School of Paramedical with Allied Health Sciences & Health Care
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-pharmacy" class="block w-full h-full">
                                                    ARNI School of Pharmacy
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-agriculture"
                                                   class="block w-full h-full">
                                                    ARNI School of Agriculture
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-law" class="block w-full h-full">
                                                    ARNI School of Law
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-hotel-management-and-tourism"
                                                   class="block w-full h-full">
                                                    ARNI School of Hotel Management & Tourism
                                                </a>
                                            </li>

                                            <li class="cursor-pointer hover:text-[#012E26] hover:font-semibold">
                                                <a href="/schools/arni-school-of-education-and-sports"
                                                   class="block w-full h-full">
                                                    ARNI School of Education & Sports
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        ACADEMIC INFO
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="/academic-info/exam-result"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Exam Results</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/academic-info/examination-schedule"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Examination Schedule</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/academic-info/examination-annual-report"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Examination Annual Report</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/academic-info/academic-calender"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Academic Calendar</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/academic-info/system-of-grading"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >System of Grading</a
                                            >
                                        </li>
                                        <!--<li>
                                            <a
                                                href="/academic-info/programme-curriculum"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Program Curriculum</a
                                            >
                                        </li>-->
                                        <li>
                                            <a
                                                href="/academic-info/university-prospectus"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >University Prospectus</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        QUICK LINKS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Testimonials</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="/whats-happening/event-calendar"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >What's Happening</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/contact-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Contact Us</a
                                            >
                                        </li>
                                        <!--  <li class="flex items-center">
                                              <i
                                                  class="fa fa-chevron-right text-[#012E26] mr-2"
                                              ></i>
                                              <a
                                                  href="quick-links/image-gallery"
                                                  class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                              >Image Gallery</a
                                              >
                                          </li>-->
                                        <!--<li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-service-request"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student Service Request</a
                                            >
                                        </li>-->
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >ADMISSIONS
                    </div
                    >
                    <!-- Mega Dropdown for Admissions -->
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8"
                    >
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        APPLYING TO ARNI
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a href="admissions/overview"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Overview</a>
                                        </li>
                                        <li>
                                            <a href="admissions/campus-virtual-tour"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Campus
                                                Virtual Tour</a>
                                        </li>
                                        <li>
                                            <a href="admissions/criteria"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Admission
                                                Criteria</a>
                                        </li>
                                        <li>
                                            <a href="admissions/flow"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Admission
                                                Flow</a>
                                        </li>
                                        <li>
                                            <a href="admissions/program-fee"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Program
                                                Fee</a>
                                        </li>
                                        <li>
                                            <a href="admissions/hostel-fee"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Hostel
                                                Fee</a>
                                        </li>
                                        <li>
                                            <a href="admissions/transportation-fee"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Transportation
                                                Fee</a>
                                        </li>
                                        <li>
                                            <a href="admissions/scholarship"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Scholarship</a>
                                        </li>
                                        <li>
                                            <a href="admissions/innovative-idea-scholarship"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Innovative
                                                Idea Scholarship</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <ul class="space-y-2 mt-12">
                                        <li>
                                            <a href="admissions/fee-structure-for-previous-year-students"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Fee
                                                Structure for Previous Year Students</a>
                                        </li>
                                        <li>
                                            <a href="admissions/education-loan-assistance"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Education
                                                Loan Assistance</a>
                                        </li>
                                        <li>
                                            <a href="admissions/how-to-apply"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">How to
                                                Apply</a>
                                        </li>
                                        <li>
                                            <a href="/quick-links/contact-us"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Counselling
                                                Centres</a>
                                        </li>
                                        <li>
                                            <a href="admissions/payment-procedure"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Payment
                                                Procedure</a>
                                        </li>
                                        <li>
                                            <a href="admissions/refund-policy"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Refund
                                                Policy</a>
                                        </li>
                                        <li>
                                            <a href="admissions/avenues-for-success"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Avenues
                                                for Success@ARNI</a>
                                        </li>
                                        <li>
                                            <a href="admissions/lateral-entry-or-migration"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">Lateral
                                                Entry/Migration</a>
                                        </li>
                                        <li>
                                            <a href="admissions/faqs"
                                               class=" cursor-pointer hover:text-[#012E26] hover:font-semibold">FAQs</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        QUICK LINKS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Testimonials</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="/whats-happening/event-calendar"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >What's Happening</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/contact-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Contact Us</a
                                            >
                                        </li>
                                        <!--     <li class="flex items-center">
                                                 <i
                                                     class="fa fa-chevron-right text-[#012E26] mr-2"
                                                 ></i>
                                                 <a
                                                     href="quick-links/image-gallery"
                                                     class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                 >Image Gallery</a
                                                 >
                                             </li>-->
                                        <!--<li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-service-request"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student Service Request</a
                                            >
                                        </li>-->
                                    </ul>
                                </div>

                                <!--
                                                                <div class="w-1/4 px-4">
                                                                    <h3
                                                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                                                    >
                                                                        STUDY ABROAD
                                                                    </h3>
                                                                    <ul class="space-y-2">
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/global-overview"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Overview</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/programs"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Programs</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/application-procedure"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Application Procedure</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/international-academic-tie-ups"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >International Academic
                                                                                Tie-Ups</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/global-knowledge-seekers"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Global Knowledge Seekers</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/newsletter"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Newsletter</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/study-abroad-office"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >Study Abroad Office</a
                                                                            >
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href="study-abroad/faqs"
                                                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                                            >FAQs</a
                                                                            >
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >CAMPUS LIFE
                    </div>
                    <!-- Mega Dropdown for Campus Life -->
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8"
                    >
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        CAMPUS FACILITIES
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="campus-life/infrastructure"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Infrastructure</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/academic-facilities"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Academic Facilities</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/campus-facilities"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Campus Facilities</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/transportation"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Transportation</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/residential-facilities"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Residential Facilities</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/campus-life/library"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Library</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/schools"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Schools</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <ul class="space-y-2 mt-12">
                                        <!--    <li>
                                                <a
                                                    href="/campus-life/auditorium"
                                                    class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                >Auditorium</a
                                                >
                                            </li>-->
                                        <li>
                                            <a
                                                href="/campus-life/it-services"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >IT Services</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/campus-life/green-campus"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Green Campus</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/ncc"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >NCC</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/extra-curricular-activities"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Extra Curricular Activities</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="campus-life/student-grievance" target="_blank"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student Grievance Redressal Cell</a
                                            >
                                        </li>
                                     <!--   <li>
                                            <a
                                                href="assets/pdf/EMPLOYEE_GRIEVANCE_REDRESSAL_CELL.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                class="cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >
                                                Staff Grievance Redressal Cell
                                            </a>
                                        </li>-->

                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        EVENT GALLERY
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="/quick-links/image-gallery"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Image Gallery</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/quick-links/video-gallery"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Video Gallery</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        QUICK LINKS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Testimonials</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/contact-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Contact Us</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="whats-happening/event-calendar"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Event Calendar</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >ABOUT
                    </div>
                    <!-- Mega Dropdown for About -->
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8"
                    >
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        GET TO KNOW ARNI
                                    </h3>
                                    <ul class="space-y-2">
                                        <!--  <li>
                                              <a
                                                  href="/about/arni-group"
                                                  class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                              >ARNI Group</a
                                              >
                                          </li>-->
                                        <li>
                                            <a
                                                href="/about/about-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Overview & Identity</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/core-values"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Core Values</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/mission-and-vision"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Vision & Mission</a
                                            >

                                        <li>
                                            <a
                                                href="about/leadership/chancellor"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Leadership</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/faculty"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Faculty</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <ul class="space-y-2 mt-12">
                                        <!--   <li>
                                               <a
                                                   href="about/history"
                                                   class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                               >History</a
                                               >
                                           </li>
                                           <li>
                                               <a
                                                   href="about/advisory-board"
                                                   class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                               >Advisory Board</a
                                               >
                                           </li>
                                           <li>
                                               <a
                                                   href="about/work-at-arni"
                                                   class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                               >Work at ARNI</a
                                               >
                                           </li>
                                           <li>
                                               <a
                                                   href="about/government-affiliations"
                                                   class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                               >Government Affiliations</a
                                               >
                                           </li>
                                           <li>
                                               <a
                                                   href="about/statutory-bodies-of-the-university"
                                                   class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                               >Statutory Bodies of the
                                                   University</a
                                               >
                                           </li>-->
                                        <!--<li>
                                            <a
                                                href="about/arni-tenders"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >ARNI Tenders</a
                                            >
                                        </li>-->
                                        <li>
                                            <a
                                                href="about/ai-integrated-program"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >AI Integrated Program</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/approvals"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Approvals</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <!--<div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        INFO ABOUT
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="about/act-statutes-ordinances"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Act, Statutes and Ordinances</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/organizational-structure"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Organizational Structure</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/rti"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >RTI</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="about/best-practice"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Best Practice</a
                                            >
                                        </li>
&lt;!&ndash;                                        <li>&ndash;&gt;
&lt;!&ndash;                                            <a&ndash;&gt;
&lt;!&ndash;                                                href="about/thrust-areas"&ndash;&gt;
&lt;!&ndash;                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"&ndash;&gt;
&lt;!&ndash;                                            >Thrust Areas</a&ndash;&gt;
&lt;!&ndash;                                            >&ndash;&gt;
&lt;!&ndash;                                        </li>&ndash;&gt;
&lt;!&ndash;                                        <li>&ndash;&gt;
&lt;!&ndash;                                            <a&ndash;&gt;
&lt;!&ndash;                                                href="about/covid-19"&ndash;&gt;
&lt;!&ndash;                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"&ndash;&gt;
&lt;!&ndash;                                            >COVID19</a&ndash;&gt;
&lt;!&ndash;                                            >&ndash;&gt;
&lt;!&ndash;                                        </li>&ndash;&gt;
&lt;!&ndash;                                        <li>&ndash;&gt;
&lt;!&ndash;                                            <a&ndash;&gt;
&lt;!&ndash;                                                href="about/psychological-counselling-cell"&ndash;&gt;
&lt;!&ndash;                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"&ndash;&gt;
&lt;!&ndash;                                            >Psychological Counselling&ndash;&gt;
&lt;!&ndash;                                                Cell</a&ndash;&gt;
&lt;!&ndash;                                            >&ndash;&gt;
&lt;!&ndash;                                        </li>&ndash;&gt;
&lt;!&ndash;                                        <li>&ndash;&gt;
&lt;!&ndash;                                            <a&ndash;&gt;
&lt;!&ndash;                                                href="about/fccs"&ndash;&gt;
&lt;!&ndash;                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"&ndash;&gt;
&lt;!&ndash;                                            >Family & Couple Counselling&ndash;&gt;
&lt;!&ndash;                                                Services(FCCS)</a&ndash;&gt;
&lt;!&ndash;                                            >&ndash;&gt;
&lt;!&ndash;                                        </li>&ndash;&gt;
                                        <li>
                                            <a
                                                href="about/analytical-center"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Analytical center</a
                                            >
                                        </li>
                                    </ul>
                                </div>-->
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        ENTREPRENEURSHIP
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="about/innovation-and-entrepreneurship"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Innovation and
                                                Entrepreneurship</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >CONNECT
                    </div
                    >
                    <!--                    &lt;!&ndash; Mega Dropdown for Connect &ndash;&gt;-->
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8"
                    >
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        WHATS HAPPENING
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="whats-happening/event-calendar"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Event Calendar</a
                                            >
                                        </li>
                                        <!--    <li>
                                                <a
                                                    href="quick-links/upcoming-events"
                                                    class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                >Upcoming Events</a
                                                >
                                            </li>-->
                                        <li>
                                            <a
                                                href="quick-links/announcements"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Announcements</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="quick-links/news"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >News</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        ALUMNI
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="/alumni/connect"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Alumni Connect</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/alumni/office-contacts"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Alumni Office Contacts</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="https://student.arni.in/" target="_blank"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student Login</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        DOWNLOADS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="downloads/brochure"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Brochure</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="downloads/registration-form"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Registration Form</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="downloads/guidelines"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Guidelines</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        QUICK LINKS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Testimonials</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/news"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >What's Happening</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/contact-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Contact Us</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/image-gallery"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Image Gallery</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <div
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >INTERNATIONAL
                    </div>
                    <div
                        class="dropdown-menu group-hover:opacity-100 group-hover:visible transition-all duration-300 text-black mt-8"
                    >
                        <div
                            class="container-fluid mx-auto px-4 py-6"
                            style="padding-bottom: 80px"
                        >
                            <div class="flex justify-between">
                                <div class="w-1/5 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        INTERNATIONAL ADMISSIONS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="international-admissions/why-choose-arni"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Why Choose ARNI</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/admissions/program-fee"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Programme Fee</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/admissions/hostel-fee"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Hostel Fee</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="form/apply-form"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >How to apply</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="international-admissions/admission-rules"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Admission Rules</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="admissions/payment-procedure"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Payment Procedure</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/admissions/scholarship"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Scholarship</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/admissions/flow"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Admission Flow</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/5 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        STUDENT INFORMATION
                                    </h3>
                                    <ul class="space-y-2">
                                        <li>
                                            <a
                                                href="student-information/student-notification"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student Notification</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/pre-arrival-information"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Pre-Arrival Information</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/post-arrival-information"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Post-Arrival Information</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/guidelines-for-visa"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Guidelines for Visa and
                                                FRO/FRRO</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/guidelines-for-medical-insurance"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Guidelines for Medical
                                                Insurance</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/hostel-rules"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Hostel Rules</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="student-information/faqs"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >FAQs</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Student's Speak</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/4 px-4">
                                    <h3
                                        class="text-lg font-bold text-[#012E26] mb-4 pb-2 border-b border-gray-200"
                                    >
                                        QUICK LINKS
                                    </h3>
                                    <ul class="space-y-2">
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/student-testimonial"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Testimonials</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/news"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >What's Happening</a
                                            >
                                        </li>
                                        <!--     <li class="flex items-center">
                                                 <i
                                                     class="fa fa-chevron-right text-[#012E26] mr-2"
                                                 ></i>
                                                 <a
                                                     href="quick-links/contact-us"
                                                     class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                                 >Help & Support</a
                                                 >
                                             </li>-->
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/contact-us"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Contact Us</a
                                            >
                                        </li>
                                        <li class="flex items-center">
                                            <i
                                                class="fa fa-chevron-right text-[#012E26] mr-2"
                                            ></i>
                                            <a
                                                href="quick-links/image-gallery"
                                                class=" cursor-pointer hover:text-[#012E26] hover:font-semibold"
                                            >Image Gallery</a
                                            >
                                        </li>

                                    </ul>
                                    <div class="mt-8">
                                        <a
                                            href="form/apply-form"
                                            class="inline-block bg-[#5ab11c] text-white px-6 py-3 rounded-full font-medium text-center"
                                        >Apply Now</a
                                        >
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item group relative">
                    <a href="research/research-overview"
                       class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white hover:bg-[#01211c]"
                    >RESEARCH</a>
                </li>
                <li class="nav-item group relative">
                    <a
                        class="block py-3 px-3 transition duration-200 font-medium cursor-pointer text-white  hover:bg-[#01211c]"
                        href="/iqac/overview"
                    >IQAC</a>
                </li>
            </ul>

            <!-- Mobile menu toggle -->
            <button
                (click)="toggleMenu()"
                class="lg:hidden px-4 transition-all duration-300 text-white"
                id="mobile-menu-button"
            >
                <i class="fa fa-bars text-xl" *ngIf="!isMenuOpen"></i>
                <i class="fa-solid fa-xmark text-xl" *ngIf="isMenuOpen"></i>
            </button>
            <!-- Apply now button -->
            <div class="hidden lg:flex items-center pr-4 gap-x-2">
                <a
                    target="_blank"
                    href="/form/apply-form"
                    style="border-radius: 4px !important;"
                    class="bg-white border border-[#012E26] text-[#012E26] px-4 py-1 text-xs xl:text-sm font-bold shadow-lg"
                >
                    APPLY NOW
                </a>
                <a
                    target="_blank"
                    href="https://exam.arni.in/auth/register"
                    style="border-radius: 4px !important;"
                    class="bg-white border border-[#012E26] text-[#012E26] px-4 py-1 text-xs xl:text-sm font-bold shadow-lg"
                >
                    SCHOLARSHIP EXAM
                </a>
            </div>

            <!--            <div class="hidden lg:flex items-center pr-4">
                            <a
                                href="/form/apply-form"
                                class="font-medium transition-all bg-white text-[#012E26]"
                            >
                                APPLY NOW
                            </a>
                            <a
                                href="https://exam.arni.in/auth/register"
                                target="_blank"
                                class="font-medium transition-all ml-2 bg-white text-[#012E26]">
                                Scholarship Exam
                            </a>
                        </div>-->
        </div>
    </div>

    <!-- Mobile menu (hidden by default) -->
    <div
        class="lg:hidden transition-all duration-300 bg-[#01211c] text-white"
        *ngIf="isMenuOpen"
        id="mobile-menu"
    >
        <ul class="px-4 py-2">
            <li
                (click)="toggleSubMenu('academics')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">Academic</div>

                <ul *ngIf="subMenus['academics']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('programme');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['programme']
                                }"
                            ></i>
                            PROGRAMS
                        </div>
                        <ul *ngIf="dropDown['programme']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/graduate" class="hover:underline">Graduate</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/post-graduate" class="hover:underline">Post Graduate</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/doctoral" class="hover:underline">Doctoral</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/diploma" class="hover:underline">Diploma</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/integrated" class="hover:underline">Integrated</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/programs/certificate" class="hover:underline">Certificate</a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('schools');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['schools']
                                }"
                            ></i>
                            SCHOOLS
                        </div>
                        <ul *ngIf="dropDown['schools']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-technology" class="hover:underline">ARNI School of
                                    Technology</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-business-management-and-commerce"
                                   class="hover:underline">
                                    ARNI School of Business Management & Commerce
                                </a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-art-and-humanities" class="hover:underline">
                                    ARNI School of Art & Humanities
                                </a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-basic-science-and-biotechnology"
                                   class="hover:underline">
                                    ARNI School of Basic Sciences & Bio-Technology
                                </a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-paramedical-with-allied-health-science-and-healthcare"
                                   class="hover:underline">
                                    ARNI School of Paramedical with Allied Health Sciences & Health Care
                                </a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-pharmacy" class="hover:underline">ARNI School of
                                    Pharmacy</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-agriculture" class="hover:underline">ARNI School of
                                    Agriculture</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-law" class="hover:underline">ARNI School of Law</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-hotel-management-and-tourism" class="hover:underline">
                                    ARNI School of Hotel Management & Tourism
                                </a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/schools/arni-school-of-education-and-sports" class="hover:underline">
                                    ARNI School of Education & Sports
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('academic-info');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['academic-info']
                                }"
                            ></i>
                            ACADEMIC INFO
                        </div>
                        <ul *ngIf="dropDown['academic-info']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/exam-result" class="hover:underline">Exam Results</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/examination-schedule" class="hover:underline">Examination
                                    Schedule</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/examination-annual-report" class="hover:underline">Examination
                                    Annual Report</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/academic-calender" class="hover:underline">Academic Calendar</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/system-of-grading" class="hover:underline">System of Grading</a>
                            </li>
                            <!--
                            <li class="ml-4 mb-1 flex items-center">
                              <a href="/academic-info/programme-curriculum" class="hover:underline">Program Curriculum</a>
                            </li>
                            -->
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/academic-info/university-prospectus" class="hover:underline">University
                                    Brochure</a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                openSubMenuDropDown('quick-links');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['quick-links']
                                }"
                            ></i>
                            QUICK LINKS
                        </div>
                        <ul *ngIf="dropDown['quick-links']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/student-testimonial" class="hover:underline">Testimonials</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/whats-happening/event-calendar" class="hover:underline">What's Happening</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/contact-us" class="hover:underline">Contact Us</a>
                            </li>
                            <!--  <li class="ml-4 mb-1 flex items-center">
                                  <a href="/quick-links/image-gallery" class="hover:underline">Image Gallery</a>
                              </li>-->
                            <!--
                            <li class="ml-4 mb-1 flex items-center">
                              <a href="/quick-links/student-service-request" class="hover:underline">Student Service Request</a>
                            </li>
                            -->
                        </ul>
                    </li>
                </ul>
            </li>
            <li
                (click)="toggleSubMenu('admissions')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">Admissions</div>

                <ul *ngIf="subMenus['admissions']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('applying-to-aarni');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['applying-to-aarni']
                                }"
                            ></i>
                            APPLYING TO ARNI
                        </div>
                        <ul *ngIf="dropDown['applying-to-aarni']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/overview" class="hover:underline">Overview</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/campus-virtual-tour" class="hover:underline">Campus Virtual
                                    Tour</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/criteria" class="hover:underline">Admission Criteria</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/flow" class="hover:underline">Admission Flow</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/program-fee" class="hover:underline">Programme Fee</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/hostel-fee" class="hover:underline">Hostel Fee</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/transportation-fee" class="hover:underline">Transportation Fee</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/scholarship" class="hover:underline">Scholarship</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/innovative-idea-scholarship" class="hover:underline">Innovative
                                    Idea Scholarship</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/fee-structure-for-previous-year-students" class="hover:underline">Fee
                                    Structure for Previous Year Students</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/education-loan-assistance" class="hover:underline">Education Loan
                                    Assistance</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/how-to-apply" class="hover:underline">How to Apply</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/quick-links/contact-us" class="hover:underline">Counselling Centres</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/payment-procedure" class="hover:underline">Payment Procedure</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/refund-policy" class="hover:underline">Refund Policy</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/avenues-for-success" class="hover:underline">Avenues for
                                    Success@ARNI</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/lateral-entry-or-migration" class="hover:underline">Lateral
                                    Entry/Migration</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/admissions/faqs" class="hover:underline">FAQs</a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                openSubMenuDropDown('study-abroad');
                                $event.stopPropagation()
                            "
                        >
                            <!--     <i
                                     class="fa-solid fa-chevron-right text-[#012E26] text-[10px] mr-1 transition-transform duration-300"
                                     [ngClass]="{
                                         'rotate-90': dropDown['study-abroad']
                                     }"
                                 ></i>
                                 Entrepreneurship-->
                        </div>
                        <!--
                                                <ul *ngIf="dropDown['study-abroad']">
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/global-overview" class="hover:underline">Overview</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/programs" class="hover:underline">Programs</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/application-procedure" class="hover:underline">Application
                                                            Procedure</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/international-academic-tie-ups" class="hover:underline">International
                                                            Academic Tie-Ups</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/global-knowledge-seekers" class="hover:underline">Global
                                                            Knowledge Seekers</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/newsletter" class="hover:underline">Newsletter</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/study-abroad-office" class="hover:underline">Study Abroad
                                                            Office</a>
                                                    </li>
                                                    <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                                        <a href="/study-abroad/faqs" class="hover:underline">FAQs</a>
                                                    </li>
                                                </ul>
                        -->
                    </li>
                </ul>
            </li>
            <li
                (click)="toggleSubMenu('campus-life')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">Campus Life</div>

                <ul *ngIf="subMenus['campus-life']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('campus-facilities');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['campus-facilities']
                                }"
                            ></i>
                            CAMPUS FACILITIES
                        </div>
                        <ul *ngIf="dropDown['campus-facilities']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/infrastructure" class="hover:underline">Infrastructure</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/academic-facilities" class="hover:underline">Academic
                                    Facilities</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/campus-facilities" class="hover:underline">Campus Facilities</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/transportation" class="hover:underline">Transportation</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/residential-facilities" class="hover:underline">Residential
                                    Facilities</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/library" class="hover:underline">Library</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/schools" class="hover:underline">Schools</a>
                            </li>
                            <!--<li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/auditorium" class="hover:underline">Auditorium</a>
                            </li>-->
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/it-services" class="hover:underline">IT Services</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/green-campus" class="hover:underline">Green Campus</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/ncc" class="hover:underline">NCC</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/extra-curricular-activities" class="hover:underline">Extra
                                    Curricular Activities</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="campus-life/student-grievance" class="hover:underline">Student Grievance
                                    Redressal Cell</a>
                            </li>
                          <!--  <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a
                                    href="assets/pdf/EMPLOYEE_GRIEVANCE_REDRESSAL_CELL.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="hover:underline"
                                >
                                    Staff Grievance Redressal Cell
                                </a>
                            </li>-->
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('event-gallery');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['event-gallery']
                                }"
                            ></i>
                            EVENT GALLERY
                        </div>
                        <ul *ngIf="dropDown['event-gallery']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/quick-links/image-gallery" class="hover:underline">Image Gallery</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/quick-links/video-gallery" class="hover:underline">Video Gallery</a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                openSubMenuDropDown('campus-quick-links');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['campus-quick-links']
                                }"
                            ></i>
                            QUICK LINKS
                        </div>
                        <ul *ngIf="dropDown['campus-quick-links']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/quick-links/student-testimonial" class="hover:underline">Testimonials</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/quick-links/contact-us" class="hover:underline">Contact Us</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/whats-happening/event-calendar" class="hover:underline">Event Calendar</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li
                (click)="toggleSubMenu('about')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">About</div>

                <ul *ngIf="subMenus['about']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('get-to-know-aarni');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['get-to-know-aarni']
                                }"
                            ></i>
                            GET TO KNOW ARNI
                        </div>
                        <ul *ngIf="dropDown['get-to-know-aarni']">
                            <!--   <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                   <a href="/about/jain-ideals" class="hover:underline">Jain Ideals</a>
                               </li>-->
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/about-us" class="hover:underline">Overview & Identity</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/core-values" class="hover:underline">Core Values</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/mission-and-vision" class="hover:underline">Vision & Mission</a>
                            </li>
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/perspective-plan" class="hover:underline">Perspective Plan</a>
                             </li>-->
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/leadership/chancellor" class="hover:underline">Leadership</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/faculty" class="hover:underline">Faculty</a>
                            </li>
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/history" class="hover:underline">History</a>
                             </li>-->
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/advisory-board" class="hover:underline">Advisory Board</a>
                             </li>-->
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/work-at-arni" class="hover:underline">Work at ARNI</a>
                             </li>-->
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/government-affiliations" class="hover:underline">Government Affiliations</a>
                             </li>-->
                            <!-- <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                 <a href="/about/statutory-bodies-of-the-university" class="hover:underline">Statutory Bodies of the University</a>
                             </li>-->
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/ai-integrated-program" class="hover:underline">AI Integrated Program</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="about/approvals" class="hover:underline">Approvals</a>
                            </li>
                        </ul>
                    </li>
                    <!--<li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('info-about');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['info-about']
                                }"
                            ></i>
                            INFO ABOUT
                        </div>
                        <ul *ngIf="dropDown['info-about']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/act-statutes-ordinances" class="hover:underline">Act, Statutes and Ordinances</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/organizational-structure" class="hover:underline">Organizational Structure</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/rti" class="hover:underline">RTI</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/best-practice" class="hover:underline">Best Practice</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/analytical-center" class="hover:underline">Analytical Center</a>
                            </li>
                        </ul>
                    </li>-->
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                openSubMenuDropDown('entrepreneurship');
                                $event.stopPropagation()
                            ">
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['entrepreneurship']
                                }"
                            ></i>
                            ENTREPRENEURSHIP
                        </div>
                        <ul *ngIf="dropDown['entrepreneurship']">
                            <li class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="/about/innovation-and-entrepreneurship" class="hover:underline">Innovation and
                                    Entrepreneurship</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li
                (click)="toggleSubMenu('connect')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">Connect</div>

                <ul *ngIf="subMenus['connect']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                  openSubMenuDropDown('connect-whats-happening');
                                  $event.stopPropagation()
                              "
                        >
                            <div
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                      'rotate-90':
                                          dropDown['connect-whats-happening']
                                  }"
                            ></div>
                            WHAT'S HAPPENING
                        </div>
                        <ul *ngIf="dropDown['connect-whats-happening']">
                            <li (click)="goTo('/whats-happening/event-calendar')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Event Calendar
                            </li>
                            <!--   <li (click)="goTo('/whats-happening/upcoming-events')"
                                   class="ml-4 mb-1 flex items-center cursor-pointer">
                                   Upcoming Events
                               </li>-->
                            <li (click)="goTo('/quick-links/announcements')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Announcements
                            </li>
                            <li (click)="goTo('/whats-happening/news')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                News
                            </li>
                            <!--  <li (click)="goTo('/whats-happening/fm-radio')"
                                  class="ml-4 mb-1 flex items-center cursor-pointer">
                                  FM Radio Suno ARNI-90.8FM
                              </li>-->
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                  openSubMenuDropDown('alumni');
                                  $event.stopPropagation()
                              "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                      'rotate-90': dropDown['alumni']
                                  }"
                            ></i>
                            ALUMNI
                        </div>
                        <ul *ngIf="dropDown['alumni']">
                            <li (click)="goTo('/alumni/connect')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                Alumni Connect
                            </li>
                            <!--   <li (click)="goTo('/alumni/overview')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                   Alumni Overview
                               </li>-->
                            <li (click)="goTo('/alumni/office-contacts')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Alumni Office Contacts
                            </li>
                            <!-- <li (click)="goTo('/alumni/become-a-mentor')"
                                 class="ml-4 mb-1 flex items-center cursor-pointer">
                                 Become a Mentor
                             </li>-->
                            <li
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                <a href="https://student.arni.in/" target="_blank">
                                    Student Login

                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                  openSubMenuDropDown('downloads');
                                  $event.stopPropagation()
                              "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                      'rotate-90': dropDown['downloads']
                                  }"
                            ></i>
                            DOWNLOADS
                        </div>
                        <ul *ngIf="dropDown['downloads']">
                            <li (click)="goTo('downloads/brochure')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                Brochure
                            </li>
                            <li (click)="goTo('downloads/registration-form')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Registration Form
                            </li>
                            <!--  <li (click)="goTo('downloads/migration-policy')"
                                  class="ml-4 mb-1 flex items-center cursor-pointer">
                                  Migration Policy
                              </li>
                              <li (click)="goTo('downloads/')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                  SOPs
                              </li>-->
                            <li (click)="goTo('downloads/guidelines')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Guidelines
                            </li>
                            <!--       <li (click)="goTo('downloads/academic-progression-rule')"
                                       class="ml-4 mb-1 flex items-center cursor-pointer">
                                       Academic Progression Rule
                                   </li>
                                   <li (click)="goTo('downloads/newsletter')"
                                       class="ml-4 mb-1 flex items-center cursor-pointer">
                                       Newsletter
                                   </li>
                                   <li (click)="goTo('downloads/the-arnins')"
                                       class="ml-4 mb-1 flex items-center cursor-pointer">
                                       The ARNIns
                                   </li>
                                   <li (click)="goTo('downloads/nba')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                       NBA
                                   </li>-->
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                  openSubMenuDropDown('connect-quick-links');
                                  $event.stopPropagation()
                              "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                      'rotate-90': dropDown['connect-quick-links']
                                  }"
                            ></i>
                            QUICK LINKS
                        </div>
                        <ul *ngIf="dropDown['connect-quick-links']">
                            <li (click)="goTo('quick-links/student-testimonial')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Testimonials
                            </li>
                            <li (click)="goTo('whats-happening/contact-us')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Contact Us
                            </li>
                            <li (click)="goTo('whats-happening/event-calendar')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Event Calendar
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li
                (click)="toggleSubMenu('international')"
                class="py-2 border-b border-green-900"
            >
                <div class="block">International Admissions</div>

                <ul *ngIf="subMenus['international']">
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('international-admissions');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90':
                                        dropDown['international-admissions']
                                }"
                            ></i>
                            INTERNATIONAL ADMISSIONS
                        </div>
                        <ul *ngIf="dropDown['international-admissions']">
                            <li (click)="goTo('international-admissions/why-choose-arni')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Why Choose ARNI
                            </li>
                            <li (click)="goTo('/admissions/program-fee')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Programme Fee
                            </li>
                            <li (click)="goTo('/admissions/hostel-fee')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Accommodation Fee
                            </li>
                            <li (click)="goTo('/form/apply-form')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                How to Apply
                            </li>
                            <li (click)="goTo('international-admissions/admission-rules')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Admission Rules
                            </li>
                            <li (click)="goTo('admissions/payment-procedure')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Payment Procedure
                            </li>
                            <li (click)="goTo('/admissions/scholarship')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Scholarship
                            </li>
                            <li (click)="goTo('/admissions/flow')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Admission Flow
                            </li>
                        </ul>
                    </li>
                    <li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('student-information');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['student-information']
                                }"
                            ></i>
                            STUDENT INFORMATION
                        </div>
                        <ul *ngIf="dropDown['student-information']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/student-notification" class="hover:underline">Student
                                    Notification</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/pre-arrival-information" class="hover:underline">Pre-Arrival
                                    Information</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/post-arrival-information" class="hover:underline">Post-Arrival
                                    Information</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/guidelines-for-visa" class="hover:underline">Guidelines
                                    for Visa and FRO/FRRO</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/guidelines-for-medical-insurance" class="hover:underline">Guidelines
                                    for Medical Insurance</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/hostel-rules" class="hover:underline">Hostel Rules</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/student-information/faqs" class="hover:underline">FAQs</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/student-testimonial" class="hover:underline">Student's Speak</a>
                            </li>
                        </ul>
                    </li>
                    <!--<li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown(
                                    'international-study-abroad'
                                );
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90':
                                        dropDown['international-study-abroad']
                                }"
                            ></i>
                            STUDY ABROAD
                        </div>
                        <ul *ngIf="dropDown['international-study-abroad']">
                            <li (click)="goTo('/study-abroad/global-overview')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Overview
                            </li>
                            <li (click)="goTo('/study-abroad/programs')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Programs
                            </li>
                            <li (click)="goTo('/study-abroad/application-procedure')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Application Procedure
                            </li>
                            <li (click)="goTo('/study-abroad/international-academic-tie-ups')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                International Academic Tie-Ups
                            </li>
                            <li (click)="goTo('/study-abroad/global-knowledge-seekers')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Global Knowledge Seekers
                            </li>
                            <li (click)="goTo('/study-abroad/newsletter')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Newsletter
                            </li>
                            <li (click)="goTo('/study-abroad/study-abroad-office')"
                                class="ml-4 mb-1 flex items-center cursor-pointer">
                                Study Abroad Office
                            </li>
                            <li (click)="goTo('/study-abroad/faqs')" class="ml-4 mb-1 flex items-center cursor-pointer">
                                FAQs
                            </li>
                        </ul>
                    </li>-->
                    <!--<li class="ml-2">
                        <div
                            class="flex items-center mb-1"
                            (click)="
                                openSubMenuDropDown('short-term-program');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90': dropDown['short-term-program']
                                }"
                            ></i>
                            SHORT TERM PROGRAM
                        </div>
                        <ul *ngIf="dropDown['short-term-program']">
                            <li class="ml-4 mb-1 flex items-center"
                                (click)="goTo('short-term-programs/certificate-programmes')">
                                Certificate Programmes
                            </li>
                            <li class="ml-4 mb-1 flex items-center"
                                (click)="goTo('short-term-programs/observership-programmes')">
                                Observership Programmes
                            </li>
                            <li class="ml-4 mb-1 flex items-center" (click)="goTo('short-term-programs/erasmus')">
                                Erasmus
                            </li>
                        </ul>
                    </li>-->
                    <li class="ml-2">
                        <div
                            class="flex items-center"
                            (click)="
                                openSubMenuDropDown('international-quick-links');
                                $event.stopPropagation()
                            "
                        >
                            <i
                                class="fa-solid fa-chevron-right text-white text-[10px] mr-1 transition-transform duration-300"
                                [ngClass]="{
                                    'rotate-90':
                                        dropDown['international-quick-links']
                                }"
                            ></i>
                            QUICK LINKS
                        </div>
                        <ul *ngIf="dropDown['international-quick-links']">
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/student-testimonial" class="hover:underline">Testimonials</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/whats-happening/event-calendar" class="hover:underline">What's happening</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/contact-us" class="hover:underline">Contact Us</a>
                            </li>
                            <li class="ml-4 mb-1 flex items-center">
                                <a href="/quick-links/image-gallery" class="hover:underline">Image Gallery</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li class="py-2 border-b border-green-900">
                <a href="/research/research-overview" class="block">Research</a>
            </li>
            <li class="py-2 border-b border-green-900">
                <a href="/iqac/overview" class="block">IQAC</a>
            </li>
            <li class="py-2">
                <a href="/form/apply-form"
                   target="_blank"
                   style="border-radius: 4px !important;"
                   class="block font-medium text-center transition-all py-3 rounded border-b border-green-900 bg-white text-[#012E26]">
                    APPLY NOW
                </a>
            </li>
            <li class="py-2">
                <a href="https://exam.arni.in/auth/register"
                   target="_blank"
                   style="border-radius: 4px !important;"
                   class="block font-medium text-center transition-all py-3 rounded border-b border-green-900 bg-white text-[#012E26]">
                    SCHOLARSHIP EXAM
                </a>
            </li>
            <li class="py-2">
                <a href="https://admin.arni.in/"
                   target="_blank"
                   style="border-radius: 4px !important;"
                   class="block font-bold text-center transition-all py-3 rounded border-b border-green-900 bg-white text-[#012E26]">
                    EMPLOYEE LOGIN
                </a>
            </li>
            <li class="py-2">
                <a href="https://student.arni.in/"
                   target="_blank"
                   style="border-radius: 4px !important;"
                   class="block font-bold text-center transition-all py-3 rounded border-b border-green-900 bg-white text-[#012E26]">
                    STUDENT LOGIN
                </a>
            </li>
        </ul>
    </div>

    <script>
        document.addEventListener("DOMContentLoaded", function () {
            const mobileMenuButton =
                document.getElementById("mobile-menu-button");
            const mobileMenu = document.getElementById("mobile-menu");

            mobileMenuButton.addEventListener("click", function () {
                mobileMenu.classList.toggle("hidden");
            });
        });
    </script>
</header>

<!-- Fixed spacer height to match the header height exactly-->
<div class="h-[32px]"></div>
